import { StrictMode } from 'react'
import { MotionConfig } from 'motion/react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App'
import { SessionProvider } from './lib/session'
import './styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('Falta #root en el HTML')

createRoot(root).render(
  <StrictMode>
    {/* Con "menos movimiento" activado en el teléfono, nada se desliza ni rebota. */}
    <MotionConfig reducedMotion="user">
      <SessionProvider>
        <App />
      </SessionProvider>
    </MotionConfig>
  </StrictMode>,
)

registerSW({ immediate: true })
